// @flow

import React from "react";
import Button from "./Button";
import "./SearchBar.scss";
import {scrollToTop} from "../../helper/anchor";
import {useTranslation} from "react-i18next";

type SearchBarProps = {
    searchProducts: string => void,
    handleChange: string => void,
    value: string,
    searchPlaceholder: string,
}

const SearchBar = (props: SearchBarProps) => {
    const {t} = useTranslation();
    const onSubmit = e => {
        e.preventDefault();
        if (props.value) {
            props.searchProducts(props.value);
        }
        scrollToTop();
    };
    return <form onSubmit={e => onSubmit(e)} className="hpm-searchBar">
        <input type="text" placeholder={props.searchPlaceholder} value={props.value}
               onChange={event => props.handleChange(event.target.value)}/>
        <Button aria-label={t("navigation.searchBarSubmit")} data-tooltip={t("navigation.searchBarSubmit")}
                name="search" type={"submit"}/>
    </form>;
};

export default SearchBar;
